import { render, staticRenderFns } from "./HolidaysOverview.vue?vue&type=template&id=09b5d8b6&"
import script from "./HolidaysOverview.vue?vue&type=script&lang=js&"
export * from "./HolidaysOverview.vue?vue&type=script&lang=js&"
import style0 from "./HolidaysOverview.vue?vue&type=style&index=0&id=09b5d8b6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports